import ImageComparison from './image-comparison';

export default ImageComparison;
